module.exports = __webpack_public_path__ + "static/media/aec-banner-main.2cac2726.jpg";